// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2S2F2","col":"CardReaderDesc_col__3y9_v","label":"CardReaderDesc_label__Yj4Pa"};